module.exports = __webpack_public_path__ + "static/media/Floor_Before.19c06740.jpg";